import { render, staticRenderFns } from "./ListForm.vue?vue&type=template&id=43b79826"
import script from "./ListForm.vue?vue&type=script&lang=js"
export * from "./ListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports